import { render, staticRenderFns } from "./ButtonTrash.vue?vue&type=template&id=a982c464"
import script from "./ButtonTrash.vue?vue&type=script&lang=js"
export * from "./ButtonTrash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports